"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Footer = ({
  children
}) => {
  return (0, _jsxRuntime.jsx)("div", {
    css: theme => [(0, _styles.wrapper)(theme)],
    children: (0, _jsxRuntime.jsx)(_styles.Content, {
      children: children
    })
  });
};
var _default = exports.default = Footer;